import React from 'react';
import { useSelector } from 'react-redux';

export default function useTeacherId() {
    
    const teacherInformation = useSelector((state: any) => state.user.userInformation);
    const teacherID: number = teacherInformation?.id;

    return teacherID;

}
